export default "__VITE_ASSET__BEYq2sOL__"